import { toastr } from "react-redux-toastr";
import { CART_ACTION_TYPES } from "./actionTypes";

export const cartActions = {
    addItem: (product, quantity = 1) => ({
        type: CART_ACTION_TYPES.ADD_ITEM,
        payload: { product, quantity },
    }),

    updateQuantity: (cartItemId, quantity) => ({
        type: CART_ACTION_TYPES.UPDATE_QUANTITY,
        payload: { cartItemId, quantity },
    }),

    updateItem: (cartItemId, updates) => ({
        type: CART_ACTION_TYPES.UPDATE_ITEM,
        payload: { cartItemId, updates },
    }),

    removeItem: (cartItemId) => ({
        type: CART_ACTION_TYPES.REMOVE_ITEM,
        payload: { cartItemId },
    }),

    clearCart: () => ({
        type: CART_ACTION_TYPES.CLEAR_CART,
    }),
};

export const addToCart = (product, quantity = 1) => (dispatch) => {
    if (!product || !product.id) {
        console.error('Попытка добавить некорректный товар в корзину', product);
        return;
    }

    dispatch(cartActions.addItem(product, quantity));

    toastr.success('Корзина', `Товар "${product.name || 'Без названия'}" добавлен.`);
};

export const updateCartItem = (cartItemId, updates) => (dispatch) => {
    dispatch(cartActions.updateItem(cartItemId, updates));
    toastr.info('Корзина', 'Параметры товара обновлены.');
};

export const changeCartItemQuantity = (cartItemId, newQuantity) => (dispatch) => {
    if (newQuantity <= 0) {
        dispatch(cartActions.removeItem(cartItemId));
    } else {
        dispatch(cartActions.updateQuantity(cartItemId, newQuantity));
    }
};

export const multiplyRemoveItem = (cartItemIds) => (dispatch) => {
    cartItemIds.forEach((cartItemId) => {
        dispatch(cartActions.removeItem(cartItemId));
    })
}